﻿export interface IPremiumValues {
    aggregateWrittenAmount: number;
    propertyLiabilityWrittenAmount: number;
    generalLiabilityWrittenAmount: number;
    commercialAutoWrittenAmount: number;    
    deliveryAutoWrittenAmount: number;
    workersCompWrittenAmount: number;
    umbrellaWrittenAmount: number;
}


export class PremiumValues implements IPremiumValues {
    public aggregateWrittenAmount: number = 0;
    public propertyLiabilityWrittenAmount: number = 0;
    public generalLiabilityWrittenAmount: number = 0;
    public commercialAutoWrittenAmount: number = 0;
    public deliveryAutoWrittenAmount: number = 0;
    public workersCompWrittenAmount: number = 0;
    public umbrellaWrittenAmount: number = 0;
}
